// Server-sent events from POST /api/chat (the hosted agent's Responses stream).

export interface StreamEvent {
  event: string;
  data: Record<string, unknown>;
}

/** Incremental SSE parser: feed text chunks, get complete events back. */
export function createSseParser() {
  let buffer = "";
  return (chunk: string): StreamEvent[] => {
    buffer += chunk.replace(/\r\n/g, "\n");
    const events: StreamEvent[] = [];
    let boundary: number;
    while ((boundary = buffer.indexOf("\n\n")) !== -1) {
      const block = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);
      let event = "message";
      const data: string[] = [];
      for (const line of block.split("\n")) {
        if (line.startsWith("event:")) event = line.slice(6).trim();
        else if (line.startsWith("data:")) data.push(line.slice(5).replace(/^ /, ""));
      }
      if (!data.length) continue;
      const raw = data.join("\n");
      if (raw === "[DONE]") continue;
      try {
        const parsed = JSON.parse(raw) as Record<string, unknown>;
        events.push({ event: typeof parsed.type === "string" && event === "message" ? parsed.type : event, data: parsed });
      } catch {
        // Ignore keep-alives and malformed frames.
      }
    }
    return events;
  };
}

export async function* readEvents(response: Response, signal?: AbortSignal): AsyncGenerator<StreamEvent> {
  if (!response.body) return;
  const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
  const parse = createSseParser();
  try {
    while (!signal?.aborted) {
      const { value, done } = await reader.read();
      if (done) break;
      yield* parse(value);
    }
  } finally {
    reader.releaseLock();
  }
}
